import { FC } from 'react';

import CapsuleTypeListing from 'components/main/CapsuleType/index';

const CapsuleType: FC = () => <CapsuleTypeListing />;

export default CapsuleType;
